export default {
  clean: () => import("/tmp/build_f381faef/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/tmp/build_f381faef/layouts/default.vue").then(m => m.default || m)
}